import React, { Fragment, FC } from 'react';
import {
  Box,
  SideSheet,
  SideSheetHeader,
  SideSheetClose,
  SideSheetSubHeader,
  SideSheetBody,
  SideSheetContentCol,
  SideSheetFooter,
  Button,
  ButtonAppearance,
} from '@bechtel/gds';
import { ViewMilestoneAttachment, TitleValue } from '@bechtel/client-common';
import { useWorkPackage } from '~/detail/context';
import { CommodityMilestone } from '@bechtel/types';
import { useCommodity } from '~/detail/commodities/context';
import { t, Trans } from '@lingui/macro';

export interface MilestoneAttachmentProps {
  closeModal: () => void;
  milestone: CommodityMilestone;
}

const MilestoneAttachment: FC<MilestoneAttachmentProps> = ({ milestone, closeModal }) => {
  const commodity = useCommodity();
  const { tag } = useWorkPackage();

  return (
    <Fragment>
      <SideSheet visible closable onDismiss={closeModal}>
        <SideSheetHeader data-testid="attachment-header" title={t`Attachments`}>
          <SideSheetClose onClick={closeModal}></SideSheetClose>
        </SideSheetHeader>
        <SideSheetSubHeader>
          <Box mb={{ sm: '300' }}>
            <TitleValue title={t`Work Package`} value={tag}></TitleValue>
          </Box>
          <Box mr={{ sm: '300' }} mb={{ sm: '300' }}>
            <TitleValue title={commodity.typeName} value={commodity.tag}></TitleValue>
          </Box>
          <Box mr={{ sm: '300' }}>
            <TitleValue title={t`Milestone`} value={milestone.name}></TitleValue>
          </Box>
        </SideSheetSubHeader>
        <SideSheetBody>
          <SideSheetContentCol>
            <ViewMilestoneAttachment attachments={milestone.attachments} />
          </SideSheetContentCol>
        </SideSheetBody>
        <SideSheetFooter>
          <Box justifyContent={{ sm: 'flex-end' }}>
            <Box>
              <Button appearance={ButtonAppearance.SECONDARY} onClick={closeModal} data-testid="close-button">
                <Trans> Close</Trans>
              </Button>
            </Box>
          </Box>
        </SideSheetFooter>
      </SideSheet>
    </Fragment>
  );
};

export default MilestoneAttachment;
